export default defineNuxtPlugin((nuxtApp) => {
  // Suppress Vue warnings on both server and client
  const app = nuxtApp.vueApp;

  if (app) {
    // Override Vue's warning handler to suppress specific Builder.io warnings
    app.config.warnHandler = (msg, instance, trace) => {
      // Suppress "Extraneous non-props attributes" warnings from Builder.io components
      if (
        msg.includes('Extraneous non-props attributes') &&
        (msg.includes('lockAspectRatio') ||
          msg.includes('builder-image') ||
          msg.includes('BuilderImage'))
      ) {
        return; // Suppress this warning
      }

      // Log all other warnings normally
      if (import.meta.server) {
        console.warn(`[Vue warn]: ${msg}${trace}`);
      } else {
        console.warn(`[Vue warn]: ${msg}${trace}`);
      }
    };
  }
});
